import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-order-id-chip',
	templateUrl: './order-id-chip.component.html',
	styleUrls: ['./order-id-chip.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderIdChipComponent implements OnInit {

	@Input()
	orderID?: string;

	@Input()
	clickable: boolean = true;

	@Input()
	customerName?: string;

	@Input()
	agencyName?: string | undefined;

	@Input()
	description?: string;

	// The messageID is an optional parameter; used when the parent component wants a message open on the order page
	@Input()
	messageID?: string;

	public getText() {
		return this.orderID
			+ (this.agencyName ? ' \u2022 ' + this.agencyName : '')
			+ (this.customerName ? ' \u2022 ' + this.customerName : '')
			+ (this.description ? ' \u2022 ' + this.description : '')
	}

	constructor (private _router: Router) { }

	ngOnInit(): void { }

	openOrder(): void {
		if (this.clickable && this.orderID) {
			const query: { [key: string]: string } = { orderId: this.orderID };

			if (this.messageID) {
				query["messageId"] = this.messageID;
			}

			this._router.navigate(['/order'], { queryParams: query });
		}
	}
}
